import FullLayout from '@/layouts/full/FullLayout.vue';
import type { RouteRecordRaw } from 'vue-router';

// ────────────────────────────────────────────────────────────
// Compras > Relatórios > Relatório de Compras (rateio de pedidos, live)
// As 3 rotas são REAIS de propósito: o syncFrontendRoutes (login do
// Admin Master) cadastra cada path na tabela `routes`, e o backend
// verifica a permissão por empresa nos paths /via e /sim (a migration
// 192 semeia as três para não depender desse login).
// A mesma view atende as 3; meta.tenant pré-seta o switcher.
// ────────────────────────────────────────────────────────────

export const comprasRelatoriosRoutes: RouteRecordRaw[] = [
  {
    path: '/compras/relatorios/pedidos',
    component: FullLayout,
    meta: { requiresAuth: true, title: 'Compras — Relatório de Compras' },
    children: [
      {
        path: '',
        name: 'RelatorioCompras',
        component: () => import('@/views/Compras/RelatorioCompras/RelatorioCompras.vue'),
        meta: {
          requiresAuth: true,
          title: 'Relatório de Compras',
          breadcrumb: 'Compras / Relatórios / Relatório de Compras',
        },
      },
      {
        path: 'via',
        name: 'RelatorioComprasVia',
        component: () => import('@/views/Compras/RelatorioCompras/RelatorioCompras.vue'),
        meta: {
          requiresAuth: true,
          tenant: 'via',
          title: 'Relatório de Compras — Via Education',
          breadcrumb: 'Compras / Relatórios / Relatório de Compras',
        },
      },
      {
        path: 'sim',
        name: 'RelatorioComprasSim',
        component: () => import('@/views/Compras/RelatorioCompras/RelatorioCompras.vue'),
        meta: {
          requiresAuth: true,
          tenant: 'sim',
          title: 'Relatório de Compras — Siminova',
          breadcrumb: 'Compras / Relatórios / Relatório de Compras',
        },
      },
    ],
  },

];

export default comprasRelatoriosRoutes;
